import { render } from "./SamplingPointRealTimeDataTable.component.vue?vue&type=template&id=bd93aca2&scoped=true&ts=true"
import script from "./SamplingPointRealTimeDataTable.component.vue?vue&type=script&lang=ts"
export * from "./SamplingPointRealTimeDataTable.component.vue?vue&type=script&lang=ts"

import "./SamplingPointRealTimeDataTable.component.vue?vue&type=style&index=0&id=bd93aca2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd93aca2"]])

export default __exports__